<template>
    <div class="fundoBase" :style="CoresLinhaHorizontal">
        <div class="tracoReto"></div>
        <div class="tracoAngular"></div>
        <div class="circuloTop"></div>
        <div class="circulo1"></div>
        <div class="circulo2"></div>
        <div class="circulo3"></div>
        <div class="circulo4"></div>
        <div class="quadrado"></div>
    </div>
</template>

<script>
export default {
    name: "LinhaHorizontal",
		data() {
			return {
                backgroundLinhas: "#000",
                CorLinhas: "#008fac"
            };
		},
	components: {},
    props: ["configLinhas"],
	computed: {
		CoresLinhaHorizontal: function () {
			return [
                {"--linhas-background-color": this.backgroundLinhas},
                {"--linhas-color": this.CorLinhas}
            ];
		}
    },
    methods: {
        setConfiguracaoInicial() {
            if(this.configLinhas) {
                if (this.configLinhas.backgroundLinhas) {
					this.backgroundLinhas = this.configLinhas.backgroundLinhas;
				}
				if (this.configLinhas.CorLinhas) {
					this.CorLinhas = this.configLinhas.CorLinhas
				}
            }
        }
    },
    created() {
            this.setConfiguracaoInicial();
    }
};
</script>

<style>

.fundoBase {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--linhas-background-color);
}

.tracoReto {
    position: absolute;
    top: 81%;
    left:18.5%;
    width: 80%;
    height: 4%;
    background-color: var(--linhas-color);
}

.tracoAngular {
    position: absolute;
    top: 48%;
    left: 0%;
    width: 22%;
    height: 4%;
    background-color: var(--linhas-color);
    transform: rotate(45deg);
}

.quadrado {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 75%;
    left: 95%;
    background-color: var(--linhas-color);
}

.circuloTop {
    position: absolute;
    width: 4%;
    height: 18%;
    top:2%;
    left: 0.5%;
    border-radius: 50%;
    background-color: var(--linhas-color);
}

.circulo1 {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 75%;
    left: 40%;
    border-radius: 50%;
    background-color: var(--linhas-color);
}

.circulo2 {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 75%;
    left: 50%;
    border-radius: 50%;
    background-color: var(--linhas-color);
}

.circulo3 {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 75%;
    left: 60%;
    border-radius: 50%;
    background-color: var(--linhas-color);
}

.circulo4 {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 75%;
    left: 70%;
    border-radius: 50%;
    background-color: var(--linhas-color);
}

</style>